import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src783933424/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/brands/[id]/content.tsx");
